import { ColumnDefinition } from './SortedTableHeader';
import { useTableColumnSettings } from './TableColumnSettingsState';
import { ACTION_COLUMN_NAMES, HIGHLIGHT_COLUMN_NAMES, TableColumnProperties } from './tableSettings';

export const applyTableColumnSettings = <TableColumnEnum extends string>(
    highlightColumns: TableColumnEnum[],
    actionColumns: TableColumnEnum[],
    columnDefinition: ColumnDefinition<TableColumnEnum>[],
    settings: TableColumnProperties<TableColumnEnum>,
): ColumnDefinition<TableColumnEnum>[] => {
    const highlightColumnDefinitions = highlightColumns.map((column) =>
        columnDefinition.find((def) => def.column === column),
    );

    const selectedColumnDefinitions = settings.map(({ column, visible }) => {
        const definition = columnDefinition.find((def) => def.column === column);
        if (definition?.alwaysVisible || visible) {
            return definition;
        }
    });

    const actionColumnDefinitions = actionColumns.map((column) =>
        columnDefinition.find((def) => def.column === column),
    );

    return [...highlightColumnDefinitions, ...selectedColumnDefinitions, ...actionColumnDefinitions].filter(
        (def) => def !== undefined,
    );
};

export const useSelectedTableColumns = <TableColumnEnum extends string>() => {
    const { tableColumnSettings, columnDefinition } = useTableColumnSettings<TableColumnEnum>();
    return applyTableColumnSettings<TableColumnEnum>(
        HIGHLIGHT_COLUMN_NAMES as TableColumnEnum[],
        ACTION_COLUMN_NAMES as TableColumnEnum[],
        columnDefinition,
        tableColumnSettings,
    );
};
